import styled from 'styled-components';

interface MenuProps {
  isOpen: boolean;
}
interface SpanNavigatorProps {
  isActive: boolean;
}

export const ContainerSidebar = styled.div<MenuProps>`
  height: 100vh;
  width: 6rem;
  left: 0;
  position: fixed;
  background: var(--color-primary);
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  a {
    margin-bottom: 2rem;
    display: inline-block;
    text-decoration: none;
    font-size: 16px;
    p {
      font-weight: 700;
      color: #fff;
    }
  }
  @media (max-width: 601px) {
    display: ${(props) => (props.isOpen ? 'flex' : ' none')};
    position: ${(props) => (props.isOpen ? 'absolute' : 'relative')};
    z-index: ${(props) => (props.isOpen ? '200' : '')};
    height: ${(props) => (props.isOpen ? '100vh' : '')};
    width: ${(props) => (props.isOpen ? '50vw' : '')};

    .close {
      background-color: transparent;
      border: none;
      font-size: 2rem;
      color: #fff;
      margin-right: -12rem;
      margin-bottom: -10rem;
    }
  }
  @media (max-width: 415px) {
    width: ${(props) => (props.isOpen ? '80vw' : '')};

    .close {
      background-color: transparent;
      border: none;
      font-size: 2rem;
      color: #fff;
      margin-right: -12rem;
      margin-bottom: -10rem;
    }
  }
`;

export const LinkNavigate = styled.span<SpanNavigatorProps>`
  margin-bottom: 2rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => (props.isActive ? '#fff' : '#A6A6A6')};
  font-size: 32px;
  cursor: pointer;
  transition: 0.2s;
  label {
    visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
    margin-top: 0.5rem;
    font-size: 11px;
    font-weight: 600;
  }
  :hover {
    color: #fff;
    label {
      visibility: visible;
    }
  }
  @media (max-width: 601px) {
    display: flex;
    flex-direction: row;
    label {
      margin-left: 1rem;
      font-size: 22px;
      visibility: visible;
    }
  }
`;
